import axios, { AxiosResponse } from "axios";
import { useState } from "react";
import { Type } from "typescript";
import { fetchData } from "../store/config";

interface Props {
  name: string
}

interface TypeQuery {
  url: string
  params: Object
  onComplete: (response: AxiosResponse, onDownload: (url: string)=>void) => void
}
const useQueryDownloadCustom = ({name}: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  /*     const [data, setData] = useState<TypeResponse | null>(null) */
  const [error, setError] = useState<any>(null)

  const onGenerate = async({ url, params, onComplete }: TypeQuery) => {
    setIsLoading(true)
    try {
      const response: AxiosResponse = await fetchData().get(url, {
        params: {
          ...params
        }
      })
      onComplete(response, onDownload)
    } catch (error) {
      setIsLoading(false)
    }
  }

  const onDownload = (url: string) => {
    axios({
      url,
      method: 'GET',
      responseType: 'blob'
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url;
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
      })
  }


  return {isLoading, onGenerate}
}

export default useQueryDownloadCustom